import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {IAppConfig} from '../../../store/interfaces/IAppConfig';
import {AppAction, IAppState} from '../../../store/interfaces/IAppState';
import {NgRedux} from '@angular-redux/store';
import {APP_CONFIG} from '../../../api/config/app.config';
import {Title} from '@angular/platform-browser';
import {ActionHandler} from '../../../store/action.handler';
import {SiteURL, SiteURLUtils} from '../../../common/site.url.utils';
import {ManageStayDelegate} from '../../../api/delegates/manage-stay.delegate';
import {Unsubscribe} from 'redux';
import {MessagesUtil} from '../../../common/messages.util';
import {RouteNames} from '../../../api/enums/route-names.enum';
import {TrackingJsonService} from '../../../api/services/trackingJson.service';
import {User} from '../../../api/model/user/user.model';
import {resolveLocale} from '../../../common/common';
import {ApplicationLocale} from '../../../common/model/application-locale.model';
import {IMessage} from "../../../api/interfaces/Messages";
import {ReservationErrorMessageKeys} from "../../../api/model/errors";
import {Reservation} from "../../../api/model/reservation";
import { Brands } from '../../../api/enums/brands.enum';
import {RESERVATION_STATUS_CANCELED} from '../../../api/model/reservation/reservation-status.model';

const ROUTE_TITLE = 'IHG | Manage Your Stay';

@Component({
  selector: 'stay-mgmt-manage-stay',
  templateUrl: './manage-stay.component.html',
  styleUrls: ['./manage-stay.component.scss']
})
export class ManageStayComponent implements OnInit, OnDestroy {
  translations: { [key: string]: string };
  public paragraphSingIn1: string;
  public paragraphSingIn2: string;
  public paragraphSingIn: string;
  message: IMessage;
  error: any = null;
  actionInProgress: boolean;
  state: IAppState;
  shouldDisplay: boolean;
  reservation: Reservation = null;
  unsubscribe: Unsubscribe;

  constructor(@Inject(APP_CONFIG) protected appConfig: IAppConfig,
              private _ngRedux: NgRedux<IAppState>,
              private _titleService: Title,
              private _manageStayDelegate: ManageStayDelegate,
              private _trackingJson: TrackingJsonService) {
    this._titleService.setTitle(ROUTE_TITLE);
  }

  ngOnInit() {
    this.message = null;
    this.shouldDisplay = this._shouldDisplayTripExtras();
    this.actionInProgress = true;
    this._manageStayDelegate.fetchMember();
    this._trackingJson.subscribeRoute(RouteNames.ManageYourStay);
    this.updateFromState();
    this.unsubscribe = this._ngRedux.subscribe( () => {
      this.updateFromState();
    });
  }

  updateFromState() {
    this.state = this._ngRedux.getState();
    if (!this.state) {
      return;
    }
    this.translations = MessagesUtil.filterTranslations(this.state.translations, 'managestay');
    if (!!this.translations['sign.in']) {
      let paragraphSingIn = this.translations['sign.in'].split('<span>');
      this.paragraphSingIn1 = paragraphSingIn[0];
      paragraphSingIn = paragraphSingIn[1].split('</span>');
      this.paragraphSingIn = paragraphSingIn[0];
      this.paragraphSingIn2 = paragraphSingIn[1];
    }
    this.reservation = this.state.reservation;
    ActionHandler.handleSuccess(this.state, AppAction.GET_MEMBER, () => {
      this._handleMember(this.state.member);
    });
    ActionHandler.handleError(this.state, AppAction.GET_MEMBER, () => {
      this._updatePageLoadInProgress(false);
    });
    ActionHandler.handleSuccess(this.state, AppAction.CHANGE_MEMBER_STATUS, () => {
      this._handleMember(this.state.member);
    });
    ActionHandler.handleSuccess(this.state, AppAction.GET_RESERVATION, () => {
      if (this.reservation.status === RESERVATION_STATUS_CANCELED) {
        this.message = MessagesUtil.fromError(this.appConfig, this.error, ReservationErrorMessageKeys.CANCELED_RESERVATION);
      } else {
        SiteURLUtils.redirectToReservationView(this.appConfig, this.reservation.confirmationNumber, this.reservation.guest.lastName);
      }
    });
    ActionHandler.handleError(this.state, AppAction.GET_RESERVATION, () => {
      this.error = this.state.error;
      if(this.error.code == '404'){
        this.message = MessagesUtil.fromError(this.appConfig, this.error, ReservationErrorMessageKeys.RESERVATION_NOT_FOUND_KEY);
      }
      else {
        this.message = MessagesUtil.fromError(this.appConfig, this.error, ReservationErrorMessageKeys.SERVICE_DOWN);
      }
    });
    ActionHandler.handleError(this.state, AppAction.ADD_MESSAGE, () =>{

    });
  }

  ngOnDestroy() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    this._trackingJson.unsubscribeRoute(RouteNames.ManageYourStay);
  }

  private _updatePageLoadInProgress(inProgress: boolean) {
    this.actionInProgress = inProgress;
    if (!this.actionInProgress) {
      this._trackingJson.setPageReady();
    }
  }

  private _handleMember(member: User) {
    if (member.isExplicit()) {
      SiteURLUtils.redirectToSiteUrl(this.appConfig, SiteURL.STAY_EVENTS);
      return;
    }
    this._updatePageLoadInProgress(false);
  }

  private _shouldDisplayTripExtras() {
    return resolveLocale(this.appConfig) === ApplicationLocale.en_US;
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/manage-stay/manage-stay/manage-stay.component.ts